import { useState } from 'react';
import { ChevronUp, ChevronDown, ArrowUpDown } from 'lucide-react';

/**
 * SortableHeader - En-tête de colonne cliquable avec indicateur de tri
 *
 * @param {Object} props
 * @param {string} props.column - Nom de la colonne (identifiant unique)
 * @param {string} props.label - Texte affiché dans l'en-tête
 * @param {string} props.sortColumn - Colonne actuellement triée
 * @param {string} props.sortDirection - Direction du tri ('asc' | 'desc')
 * @param {function} props.onSort - Callback appelé au clic (column) => void
 * @param {string} [props.align='left'] - Alignement du contenu ('left' | 'right' | 'center')
 */
function SortableHeader({ column, label, sortColumn, sortDirection, onSort, align = 'left' }) {
  const [isHovered, setIsHovered] = useState(false);
  const isActive = sortColumn === column;

  return (
    <th
      onClick={() => onSort(column)}
      style={{
        padding: '0.75rem 1rem',
        textAlign: align,
        fontWeight: '600',
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'background-color 150ms',
        backgroundColor: isHovered ? 'rgba(255,255,255,0.1)' : 'transparent'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.375rem',
        justifyContent: align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start'
      }}>
        {label}
        <span style={{ opacity: isActive ? 1 : 0.4, display: 'flex', alignItems: 'center' }}>
          {isActive ? (
            sortDirection === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />
          ) : (
            <ArrowUpDown size={12} />
          )}
        </span>
      </div>
    </th>
  );
}

export default SortableHeader;
